module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/434.455b58bf.png";